module.exports = __webpack_public_path__ + "static/media/2_pl.eb1d9e5a.png";